export default {"src":"/_next/static/media/graphic.1563d35e.svg","height":160,"width":161,"blurWidth":0,"blurHeight":0};